import axios, {
  AxiosError,
  AxiosResponse,
} from "axios";
import {
  GenericResponse,
  RequestResetPassword,
  ResponseResetPassword,
} from "../types/types";
import appProps from "../AppConfigContext";

const instance = axios.create({
  baseURL: appProps.BASE_URL
});

instance.interceptors.request.use(async (config) => {
  config.headers["Content-Type"] = "application/json";
  config.headers.Accept = "application/json";
  return config;
});

export const resetPassword = (
  request: RequestResetPassword
): Promise<AxiosResponse<GenericResponse<ResponseResetPassword>>> =>
  new Promise<AxiosResponse<GenericResponse<ResponseResetPassword>>>((resolve, reject) => {
    const path = "/password/reset-password";
    instance
      .post(path, request)
      .then((response: AxiosResponse<GenericResponse<ResponseResetPassword>>) => {
        resolve(response);
      })
      .catch((error: AxiosError) => {
        reject(error);
      });
  });
